import { LoanType } from "@/modules/loan/common/enum";
import type { ITabItemsProps } from "@/shared/common/types";

export const getLoanTabItems = ({ t }: ITabItemsProps) => [
  {
    value: LoanType.Standard,
    label: t("loans.adjusted"),
    dataId: "adjusted-tab",
    disabled: false,
  },
  {
    value: LoanType.CreditLine,
    label: t("loans.credit"),
    dataId: "credit-tab",
    disabled: false,
  },
  {
    value: LoanType.Overdraft,
    label: t("loans.overdraft"),
    dataId: "overdraft-tab",
    disabled: false,
  },
  {
    value: LoanType.Leasing,
    label: t("loans.leasing"),
    dataId: "leasing-tab",
    disabled: false,
  },
  {
    value: LoanType.Factoring,
    label: t("loans.factoring"),
    dataId: "factoring-tab",
    disabled: false,
  }];
